<script>
/**
 * ****************************************************************************
 * @description     :   Select Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import _ from 'lodash';
// import helpers from '../../utils/helpers';
/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of select component
 */
var BsSelect = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        emptyText: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        removeEmptyOption: Boolean,
        options: Array,
        onChangeEvent: Function,
        onFocus: Function,
        onBlur: Function
    },
    emits: ['update:modelValue'],
    computed: {
        vewValue() {
            const val = this.modelValue ? this.modelValue : this.value;
            // const options = this.listOptions;
            // if (options && options.length > 0) {
            //     const idx = _.findIndex(options, function (o) {
            //         return o.code == val;
            //     });
            //     if (idx < 0) {
            //         const newVal = this.removeEmptyOption
            //             ? `${options[0].code}`
            //             : '';
            //         if (
            //             !(
            //                 (helpers.isNullOrEmpty(val) || `${val}` === '0') &&
            //                 (helpers.isNullOrEmpty(newVal) ||
            //                     `${newVal}` === '0')
            //             )
            //         ) {
            //             this.$emit('update:modelValue', newVal);
            //             if (this.onChangeEvent) {
            //                 this.onChangeEvent({}, newVal);
            //             }
            //             return newVal;
            //         }
            //     }
            // }
            return val;
        },
        listOptions() {
            if (!this.options) {
                return [
                    {
                        code: '',
                        name: ''
                    }
                ];
            }
            const idx = _.findIndex(this.options, function (o) {
                return (
                    o.name === '' || o.name === 'すべて' || o.name === '全て'
                );
            });
            if (idx < 0) {
                this.options.unshift({
                    code: '',
                    name: ''
                });
            }
            return this.options;
        }
    },
    methods: {
        /**
         * event forcus on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * click update item for select element
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            // if (this.isMobile) {
            //     const vewValue = this.$refs.select.value;
            //     const textValue =
            //         e.target.options[e.target.options.selectedIndex].text;
            //     this.$emit('update:modelValue', {
            //         id: vewValue,
            //         text: textValue
            //     });
            //     if (this.onChange) {
            //         this.onChange(e, vewValue);
            //     }
            // } else {
            //     const vewValue = this.$refs.select.value;
            //     this.$emit('update:modelValue', vewValue);
            //     if (this.onChange) {
            //         this.onChange(e, vewValue);
            //     }
            // }
            const vewValue = this.$refs.select.value;
            this.$emit('update:modelValue', vewValue);
            if (this.onChange) {
                this.onChange(e, vewValue);
            }
        }
    }
};
export default BsSelect;
</script>
